import { get, post } from './api';
import { VendorType } from '../components';

const endpoints = {
  authUrl: `${window.envConfig.MURRAY_API_BASE_URL}v1/Accounts/ApplicationAuthenticationToken`,
  mappedSellers: `${window.envConfig.SELLERS_API_BASE_URL}users/sellers`,
};

export type CustomerDataType = {
  email: string;
  expiresIn: number;
  firstName: string;
  lastName: string;
  token: string;
  userId: string;
};

export const checkAuth = async (request?: any): Promise<CustomerDataType> => {
  const results = await post<CustomerDataType>({
    url: endpoints.authUrl,
    body: request,
  });
  return results;
};

export const getMappedSellers = async (
  token: string
): Promise<VendorType[]> => {
  const results = await get<VendorType[]>({
    url: endpoints.mappedSellers,
    token,
  });
  return results;
};
